import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'
import { useQuery } from '@tanstack/react-query'
import { OriginalDocumentListType } from './types'

const fetchOriginalDocumentList = async (claimId: string) => {
  const response = await httpClientPrivate.get<OriginalDocumentListType>(
    `${config.restUrl}/v1/backoffice/e-claim/${claimId}/original-document-list`,
  )

  return response.data
}

const useOriginalDocumentList = (claimId: string) => {
  const queryKey = ['useOriginalDocumentList', claimId]
  const queryFn = async () => fetchOriginalDocumentList(claimId)

  const queryResult = useQuery({
    queryKey,
    queryFn,
    enabled: !!claimId, // Only run the query if claimId is provided
  })

  return { ...queryResult }
}

export { fetchOriginalDocumentList, useOriginalDocumentList }
